import React from "react";

const ImageBanner = ({
	type = "desktop", // 'desktop' | 'mobile'
	title = "Title Here",
	bgColor = "#B7D974",

	// Desktop-specific styles
	titlePosition = { top: "top-[155px]", left: "left-[66px]" },
	titleStyle = "font-extrabold text-[30px] leading-none text-[#17382F]",
	containerWidth = "w-[1261px]",
	containerHeight = "h-[228.68px]",
	marginTop = "mt-[14px]",
	marginLeft = "",
	bottomImageSrc = "/assets/success-stories/xl/bannerBottom.svg",
	rightImageSrc = "/assets/success-stories/xl/bannerRightSide.svg",

	// Mobile-specific styles
	mobileTitlePosition = { top: "top-[220px]", left: "left-[10px]" },
	mobileTitleStyle = "font-extrabold text-[16px] leading-tight text-[#17382F]",
	mobileContainerWidth = "w-[378px]",
	mobileContainerHeight = "h-[350px]",
	mobileBottomImageSrc = "/assets/success-stories/mobile/bannerBottom.svg",
	mobileRightImageSrc = "/assets/success-stories/mobile/bannerRightSide.svg",

	className = "",
}) => {
	const isMobile = type === "mobile";

	return (
		<div
			className={`relative flex flex-col ${isMobile ? `${mobileContainerWidth} ${mobileContainerHeight} top-[20px] sm:flex md:hidden lg:hidden  whitespace-pre-line` : `${containerWidth} ${containerHeight} ${marginTop} ${marginLeft} hidden lg:flex`} bg-[${bgColor}] ${className}`}
		>
			<p
				className={`absolute ${
					isMobile
						? `${mobileTitlePosition.top} ${mobileTitlePosition.left} w-[300px] font-['Montserrat'] ${mobileTitleStyle}`
						: `${titlePosition.top} ${titlePosition.left} w-[597px] h-[69px] font-['Montserrat'] ${titleStyle}`
				}`}
			>
				{title.split("\n").map((line, index) => (
					<span key={index}>
						{line}
						<br />
					</span>
				))}
			</p>

			<img
				loading="lazy"
				decoding="async"
				src={isMobile ? mobileBottomImageSrc : bottomImageSrc}
				alt="Bottom Decoration"
				className="absolute bottom-0 left-0 w-full object-cover"
			/>

			<img
				loading="lazy"
				decoding="async"
				src={isMobile ? mobileRightImageSrc : rightImageSrc}
				alt="Right Bottom Decoration"
				className={`absolute bottom-0 right-0 ${isMobile ? "w-[220px] h-auto" : "w-[219.47px] h-[288.3px]"} object-contain`}
			/>
		</div>
	);
};

export default ImageBanner;
